import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, Accordion,
  AccordionSummary,
  AccordionDetails,
  TableCell,
  Table,
  TableBody,
  TableHead,
  TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import Typography from '@material-ui/core/Typography';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import Chip from '@material-ui/core/Chip';
import { red, blue } from '@material-ui/core/colors';
import xlsx from 'json-as-xlsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  cardroot: {
    minWidth: 275,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorReject: {
    backgroundColor: "red",
  },
  colorApprove: {
    backgroundColor: "green",
  },
  card: {
    flexGrow: 10,
    backgroundColor: "#ffffff",
    paddingInlineStart: '10px',
    borderRadius: '10px',
  },
  avatar: {
    backgroundColor: red[500],
  },
  blue: {
    backgroundColor: blue[500],
  },
  succes: {
    backgroundColor: "#e8f5e9"
  },
  failed: {
    backgroundColor: "#fce4ec"
  },
  mainButtons: {
    marginRight: '0.5rem'
  },
  bold: {
    fontWeight: 600
  }
}));

const screenCode = 'BALANCEPAYMENTSUMMARYREPORT';

export default function BalancePaymentSummaryReport(props) {
  const [title, setTitle] = useState("Balance Payment Summary");
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [balance, setBalance] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [balancePayment, setBalancePayment] = useState({
    balancePaymentSummaries: [],
    factoryItems: [],
    noOfActiveAccounts: 0
  });
  const [collectionTypeRate, setCollectionTypeRate] = useState({
    groupID: 0,
    factoryID: 0,
    year: '',
    month: ''
  });
  const [allPayments, setAllPayments] = useState([]);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/');
  }
  const alert = useAlert();
  const currentProps = {
    border: 3,
    style: { width: '10rem', height: '5rem' },
  };

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isBalanceRateChangeEnabled: false,
  });
  const [LedgerCsvHeaders, SetledgerCsvHeaders] = useState([]);
  const [RouteWiseCsvHeaders, SetrouteWiseCsvHeaders] = useState([]);

  useEffect(() => {
    setSelectedDate();
    getPermissions();
    trackPromise(
      getGroupsForDropdown()
    );

  }, []);

  useEffect(() => {
    setSelectedDate();
    getFactoriesForDropdown();
  }, [collectionTypeRate.groupID]);

  useEffect(() => {
    setSelectedDate();
  }, [collectionTypeRate.factoryID]);

  useEffect(() => {
    if (collectionTypeRate.factoryID > 0 && collectionTypeRate.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [collectionTypeRate.factoryID, collectionTypeRate.groupID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBALANCEPAYMENTSUMMARYREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isBalanceRateChangeEnabled = permissions.find(p => p.permissionCode === 'BALANCERATEPERMISSION');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isBalanceRateChangeEnabled: isBalanceRateChangeEnabled !== undefined
    });

    setCollectionTypeRate({
      ...collectionTypeRate,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }


  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(collectionTypeRate.groupID);
    setFactories(factories);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items
  }

  async function generateSummaryReport() {
    trackPromise(GetSummary())
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    try {
      var response = await services.GetBalancePaymentYearMonth(collectionTypeRate.groupID, collectionTypeRate.factoryID);

      const applicableYear = parseInt(response.applicableYear);
      const applicableMonth = parseInt(response.applicableMonth) - 1;

      const selectedDate = new Date(applicableYear, applicableMonth);

      setSelectedDate(selectedDate);
      setSelectedDatePDF(response);
    } catch (error) {
      console.error("Error fetching balance payment year and month:", error);
    }
  };

  async function GetSummary() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();

    let model = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }
    const balancePay = await services.GetBalancePaymentSummary(model);
    if (balancePay.statusCode == "Success" && balancePay.data != null) {
      let totalDebit = 0;
      let totalCredit = 0;
      balancePay.data.balancePaymentSummaries.forEach(x => {
        if (x.entryType == 2) {
          totalDebit += x.total
        } else {
          totalCredit += x.total
        }
      });
      setTotalDebit(totalDebit);
      setTotalCredit(totalCredit);
      setBalancePayment(balancePay.data);
      setBalance(true)
    }
    else {
      alert.error("Error");
      setBalance(false)
    }
  }

  async function downloadBalancePaymentLedger() {
    trackPromise(GetBalancePaymentLedger())
  }

  async function GetBalancePaymentLedger() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    let model = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }

    const balancePay = await services.GetBalancePaymentDetailedData(model);

    if (balancePay.statusCode == "Success" && balancePay.data != null) {

      createBalancePaymentLedgerxlx(balancePay.data);
      alert.success("Success");

    }
    else {
      alert.error("Error");
    }
  }

  async function GetAllPaymentDetailedData() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    let model = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }

    const balancePay = await services.GetAllPaymentDetailedData(model);

    setAllPayments(balancePay.data);

    if (balancePay.statusCode == "Success" && balancePay.data != null) {
      createBalancePaymentLedgerxlx(balancePay.data);
      alert.success("Success");

    }
    else {
      alert.error("Error");
    }
  }

  async function GetBalancePaymentEstimatedLedger() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    let model = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }

    const balancePay = await services.GetBalancePaymentEstimatedLedger(model);

    if (balancePay.statusCode == "Success" && balancePay.data != null) {
      let updatedList = await ReCalculateBalancePaymentAmount(balancePay.data)
      createBalancePaymentEstimatedLedgerxlx(updatedList);
      alert.success("Success");
    }
    else {
      alert.error("Error");
    }
  }


  async function ReCalculateBalancePaymentAmount(balancepaymentDataList) {
    balancepaymentDataList.forEach(element => {


      var tempModel = {
        "Balance Payment": element["Balance Payment"],
        "Balance Brought Forward": element["Balance Brought Forward"]
      };

      delete element["Balance Payment"];
      delete element["Balance Brought Forward"];

      element = Object.assign(element, tempModel)

      element["Balance Payment"] = 0;
      element["Balance Brought Forward"] = 0;

      let balancePaymentAmount = (
        element["GrossPay"] === null || NaN ? 0 : element["GrossPay"]
          + element["Addition"] === null || NaN ? 0 : element["Addition"]
            + element["Balance Payment Forward"] === null || NaN ? 0 : element["Balance Payment Forward"]
      ) - (
          element["Advance Payment"] === null || NaN ? 0 : element["Advance Payment"]
            + element["Advance Payment Bank"] === null || NaN ? 0 : element["Advance Payment Bank"]
              + element["Advance Payment Cheque"] === null || NaN ? 0 : element["Advance Payment Cheque"]
                + element["Deduction"] === null || NaN ? 0 : element["Deduction"]
                  + element["Factory Item"] === null || NaN ? 0 : element["Factory Item"]
                    + element["Transport Rate"] === null || NaN ? 0 : element["Transport Rate"]
                      + element["Balance Carry Forward"] === null || NaN ? 0 : element["Balance Carry Forward"]
        )

      element["Balance Payment"] = balancePaymentAmount >= 0 ? balancePaymentAmount : 0
      element["Balance Brought Forward"] = balancePaymentAmount < 0 ? balancePaymentAmount : 0
    });
    return balancepaymentDataList
  }

  async function downloadRoutewiseBalancepayment() {
    trackPromise(GetRoutewiseBalancepayment())
  }

  async function GetRoutewiseBalancepayment() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    let model = {
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    }

    const balancePay = await services.GetRoutewiseBalancepayment(model);
    if (balancePay.statusCode == "Success" && balancePay.data != null) {
      createRouteuWiseBalancePaymentxlx(balancePay.data);
      alert.success("Success");

    }
    else {
      alert.error("Error");
    }
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCollectionTypeRate({
      ...collectionTypeRate,
      [e.target.name]: value
    });

  }

  const defaultDate = new Date();
  defaultDate.setMonth(defaultDate.getMonth() - 1);

  const thisYearPrevMonth = new Date();
  thisYearPrevMonth.setMonth(thisYearPrevMonth.getMonth() - 1);
  thisYearPrevMonth.setFullYear(thisYearPrevMonth.getFullYear());

  function handleDateChange(date) {
    var month = date.getMonth() + 1;
    var year = date.getUTCFullYear();

    setCollectionTypeRate({
      ...collectionTypeRate,
      month: month.toString(),
      year: year.toString()
    });

    setSelectedDatePDF({
      ...selectedDatePDF,
      applicableYear: year.toString(),
      applicableMonth: month.toString()
    })

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth()
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)

      }
    } else {
      setSelectedDate(date)
    }
  };

  if (!selectedDate) {
    setSelectedDate(thisYearPrevMonth);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function createBalancePaymentLedgerxlx(data) {
    var settings = {
      sheetName: 'Balance Payment Ledger',
      fileName: 'Balance Payment Ledger',
      writeOptions: {}
    }

    let keys = Object.keys(data[0])
    let tempcsvHeaders = LedgerCsvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let total = [];
    data.forEach(x => {
      for (var property in x) {
        if (property != "RouteName" && property != "RegistrationNumber" && property != "Name") {
          total.push({ name: property, value: x[property] })
        }
      }
    })

    const res = Array.from(total.reduce(
      (m, { name, value }) => m.set(name, value != null ? parseFloat(m.get(name) || 0) + parseFloat(value) : parseFloat(m.get(name) || 0) + parseFloat(0)), new Map
    ), ([name, value]) => ({ name, value }));

    let newRes = [];
    newRes['RouteName'] = 'Total'
    res.forEach(x => {
      newRes[x.name] = x.value
    })
    data.push(newRes)

    data.push({});

    let gr = [];
    let fr = [];
    let mr = [];
    gr['RouteName'] = 'Group: ' + groups[collectionTypeRate.groupID]
    data.push(gr);
    fr['RouteName'] = 'Factory: ' + factories[collectionTypeRate.factoryID]
    data.push(fr);
    mr['RouteName'] = 'Month: ' + selectedDatePDF.applicableMonth + ' , ' + 'Year: ' + selectedDatePDF.applicableYear
    data.push(mr);

    let mergedData = [
      {
        sheet: 'Balance Payment Ledger',
        columns: tempcsvHeaders,
        content: data
      }
    ]

    xlsx(mergedData, settings);
  }

  function createBalancePaymentEstimatedLedgerxlx(data) {
    var settings = {
      sheetName: 'Balance Payment Estimated Ledger',
      fileName: 'Balance Payment Estimated Ledger',
      writeOptions: {}
    }

    let keys = Object.keys(data[0])
    let tempcsvHeaders = LedgerCsvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let total = [];
    data.forEach(x => {
      for (var property in x) {
        if (property != "RouteName" && property != "RegistrationNumber" && property != "Name") {
          total.push({ name: property, value: x[property] })
        }
      }
    })

    const res = Array.from(total.reduce(
      (m, { name, value }) => m.set(name, value != null ? parseFloat(m.get(name) || 0) + parseFloat(value) : parseFloat(m.get(name) || 0) + parseFloat(0)), new Map
    ), ([name, value]) => ({ name, value }));

    let newRes = [];
    newRes['RouteName'] = 'Total'
    res.forEach(x => {
      newRes[x.name] = x.value
    })
    data.push(newRes)

    data.push({});

    let gr = [];
    let fr = [];
    let mr = [];
    gr['RouteName'] = 'Group: ' + groups[collectionTypeRate.groupID]
    data.push(gr);
    fr['RouteName'] = 'Factory: ' + factories[collectionTypeRate.factoryID]
    data.push(fr);
    mr['RouteName'] = 'Month: ' + selectedDatePDF.applicableMonth + ' , ' + 'Year: ' + selectedDatePDF.applicableYear
    data.push(mr);

    let mergedData = [
      {
        sheet: 'Balance Payment Ledger',
        columns: tempcsvHeaders,
        content: data
      }
    ]

    xlsx(mergedData, settings);
  }

  function createRouteuWiseBalancePaymentxlx(data) {
    var settings = {
      sheetName: 'Route wise Balance Payment',
      fileName: 'Route wise Balance Payment',
      writeOptions: {}
    }

    let keys = Object.keys(data[0])
    let tempcsvHeaders = RouteWiseCsvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    var total = [];
    data.forEach(x => {
      for (var property in x) {
        if (property !== "RouteName") {
          total.push({ name: property, value: x[property] });
        }
      }
    });

    const res = Array.from(total.reduce(
      (m, { name, value }) => m.set(name, value != null ? parseFloat(m.get(name) || 0) + parseFloat(value) : parseFloat(m.get(name) || 0) + parseFloat(0)), new Map
    ), ([name, value]) => ({ name, value }));

    let newRes = [];
    newRes['RouteName'] = 'Total'
    res.forEach(x => {
      newRes[x.name] = x.value
    })
    data.push(newRes)

    data.push({});

    let gr = [];
    let fr = [];
    let mr = [];
    gr['RouteName'] = 'Group: ' + groups[collectionTypeRate.groupID]
    data.push(gr);
    fr['RouteName'] = 'Factory: ' + factories[collectionTypeRate.factoryID]
    data.push(fr);
    mr['RouteName'] = 'Month: ' + selectedDatePDF.applicableMonth + ' , ' + 'Year: ' + selectedDatePDF.applicableYear
    data.push(mr);

    let mergedData = [
      {
        sheet: 'Route wise Balance Payment',
        columns: tempcsvHeaders,
        content: data
      }
    ]

    xlsx(mergedData, settings);
  }


  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: collectionTypeRate.groupID,
              factoryID: collectionTypeRate.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={collectionTypeRate.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}

                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={collectionTypeRate.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}

                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={4} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="outlined"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month"
                                helperText="Select applicable month"
                                value={selectedDate}
                                disableFuture={true}
                                onChange={(date) => handleDateChange(date)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>


                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            variant="contained"
                            type="button"
                            onClick={() => generateSummaryReport()}
                            className={classes.mainButtons}
                          >
                            View Summary
                          </Button>
                          {/* <Button
                            color="primary"
                            variant="contained"
                            type="button"
                            onClick={() => downloadRoutewiseBalancepayment()}
                            className={classes.mainButtons}
                          >
                            Route wise Balance payment
                          </Button> */}

                          <Button
                            color="primary"
                            variant="contained"
                            type="button"
                            onClick={() => downloadBalancePaymentLedger()}
                            className={classes.mainButtons}
                          >
                            Balance Payment Details
                          </Button>

                          <Button
                            color="primary"
                            variant="contained"
                            type="button"
                            onClick={() => trackPromise(GetBalancePaymentEstimatedLedger())}
                            className={classes.mainButtons}
                          >
                            Balance Payment Estimation
                          </Button>

                          <Button
                            color="primary"
                            variant="contained"
                            type="button"
                            onClick={() => trackPromise(GetAllPaymentDetailedData())}
                            className={classes.mainButtons}
                          >
                            All Payment Details
                          </Button>
                        </Box>

                        <br />

                      </CardContent>
                      {balance ?
                        <Grid >
                          <Card className={classes.cardroot}>
                            <CardContent>
                              <Box style={{ width: '97%' }}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell style={{ fontSize: '18px' }}>Transaction Type</TableCell>
                                      <TableCell style={{ fontSize: '18px' }}> Debit (LKR)</TableCell>
                                      <TableCell style={{ fontSize: '18px' }}>Credit (LKR)</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {balancePayment.balancePaymentSummaries.map((row, index) => (
                                      row.transactionTypeName === "Factory Item" ? (
                                        <TableRow key={index} style={{ padding: '0' }}>
                                          <TableCell colSpan={3} style={{ padding: '0' }}>
                                            <Accordion style={{ width: '100%', boxShadow: 'none' }}>
                                              <AccordionSummary style={{ width: '103%', padding: '0', marginTop: 0, height: 20 }} expandIcon={<ExpandMoreIcon />}>
                                                <Table style={{ width: '100%', padding: '0', marginLeft: -1 }}>
                                                  <TableRow>
                                                    <TableCell style={{ width: '50%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px' }}>{row.transactionTypeName}</TableCell>
                                                    <TableCell style={{ width: '25%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px' }}>{row.entryType == 2 ? row.total.toFixed(2) : "--"}</TableCell>
                                                    <TableCell style={{ width: '25%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px' }}>{row.entryType == 1 ? row.total.toFixed(2) : "--"}</TableCell>
                                                  </TableRow>
                                                </Table>
                                              </AccordionSummary>
                                              <AccordionDetails style={{ width: '100%', padding: '0', backgroundColor: '#DFF3CD' }}>
                                                <TableRow style={{ width: '100%', display: 'flex' }}>
                                                  <Table style={{ width: '100%' }}>
                                                    <TableRow style={{ backgroundColor: '#EBFFD9' }}>
                                                      <TableCell style={{ width: '40%', padding: 6, borderBottom: '0px', textAlign: 'center', fontSize: '16px' }}><b>Item Name</b></TableCell>
                                                      <TableCell style={{ width: '30%', padding: 6, borderBottom: '0px', textAlign: 'left', fontSize: '16px' }}><b>This Month Issued</b></TableCell>
                                                      <TableCell style={{ width: '30%', padding: 6, borderBottom: '0px', textAlign: 'left', fontSize: '16px' }}><b>Previous Month Issued</b></TableCell>
                                                    </TableRow>
                                                    {balancePayment.factoryItems.map((rows, i) => (
                                                      <TableRow key={i} style={{ backgroundColor: i % 2 === 0 ? '#DFF3CD' : '#EBFFD9' }}>
                                                        <TableCell style={{ width: '50%', padding: 6, borderBottom: '0px', textAlign: 'center', fontSize: '16px' }}>{rows.itemName}</TableCell>
                                                        <TableCell style={{ width: '25%', padding: 6, borderBottom: '0px', textAlign: 'left', fontSize: '16px' }}>{rows.thisMonth != 0 ? rows.thisMonth.toFixed(2) : "--"}</TableCell>
                                                        <TableCell style={{ width: '25%', padding: 6, borderBottom: '0px', textAlign: 'left', fontSize: '16px' }}>{rows.previousMonth != 0 ? rows.previousMonth.toFixed(2) : "--"}</TableCell>
                                                      </TableRow>
                                                    ))}
                                                  </Table>
                                                </TableRow>
                                              </AccordionDetails>
                                            </Accordion>
                                          </TableCell>
                                        </TableRow>
                                      ) : (
                                        <TableRow key={index}>
                                          <TableCell style={{ width: '50%', marginTop: 0, height: 20, fontSize: '16px' }}>{row.transactionTypeName}</TableCell>
                                          <TableCell style={{ width: '20%', marginTop: 0, height: 20, fontSize: '16px' }}>{row.entryType == 2 ? row.total.toFixed(2) : "--"}</TableCell>
                                          <TableCell style={{ width: '20%', marginTop: 0, height: 20, fontSize: '16px' }}>{row.entryType == 1 ? row.total.toFixed(2) : "--"}</TableCell>
                                        </TableRow>
                                      )
                                    ))}
                                    <TableRow>
                                      <TableCell style={{ width: '50%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px', fontWeight: 'bold' }}>Total</TableCell>
                                      <TableCell style={{ width: '25%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px', fontWeight: 'bold' }}>{totalDebit != 0 ? totalDebit.toFixed(2) : "--"}</TableCell>
                                      <TableCell style={{ width: '25%', marginTop: 0, height: 20, borderBottom: '0px', fontSize: '16px', fontWeight: 'bold' }}>{totalCredit != 0 ? totalCredit.toFixed(2) : "--"}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                                <br />
                                <Grid container align="center" justify="center" alignItems="center">
                                  <Grid item xs={4} spacing={2}>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                      <Chip style={{ marginLeft: '1rem', backgroundColor: "#44a6c6 " }} alignContent="center"
                                        icon={<PeopleAltIcon />}
                                        label={"Number Of Active Accounts : " + balancePayment.noOfActiveAccounts}
                                        color="primary"
                                      />
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Box>
                              <br />
                            </CardContent>
                          </Card>
                        </Grid> :
                        null
                      }
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
};
